
import { Link } from 'react-router-dom';

import { Globe } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

import { getInfo, keyOf } from '@Components/Grid/components/Table/formatters';

export default function Generator({ info, asLabel }) {
  const { row } = getInfo(info)
  const targetId = keyOf(info, 'generator')
  const target = asLabel ? <span>URL Generator</span> : <DefaultTooltip content='URL Generator'><Globe size={16} /></DefaultTooltip>

  return <>
    <Link to={`/offer/allocations/${row.id}/generator`} id={targetId}>
      {target}
    </Link>
  </>
}
